// extracted by mini-css-extract-plugin
export default {"inputsWrapper":"InputsColumnWrapper_inputsWrapper__StXA3"};